/**
 * 답변 부품 모양을 붙이는 remark 플러그인(새 문법 없음 — 모델이 원래 쓰는 마크다운만 본다).
 * - 단계: 최상위 번호 목록 3개 이상 중, 앞 제목·문단이 순서·절차를 말하거나 항목 절반 이상이 '도입'·'1단계'·'10분' 처럼 시작하면 `wq-steps`.
 * - 체크리스트: 모든 항목이 `- [ ]`·`- [x]` 인 목록은 `wq-checklist`.
 * 추천 목록(1. **경복궁** …)처럼 순서가 없는 번호 목록은 그대로 둔다.
 */

const STEPS_MIN_ITEMS = 3;
const STEP_CONTEXT_RE = /(단계|순서|절차|과정|흐름|진행|방법|하는\s*법|요령|차시|일정|타임라인|step)/i;
const STEP_LEAD_RE = /^\s*[([【]?\s*(?:\d+\s*단계|step\s*\d+|\d+\s*(?:분|차시|교시|주차|일차|일째)|도입|전개|정리|마무리|준비|발문)/i;
const CONTEXT_MAX_CHARS = 80;

const textOf = (node) => {
  if (!node) return '';
  if (typeof node.value === 'string') return node.value;
  return (node.children || []).map(textOf).join('');
};

const addClass = (node, className) => {
  node.data = node.data || {};
  const props = node.data.hProperties || {};
  node.data.hProperties = { ...props, className: [].concat(props.className || [], className) };
};

/** 목록 바로 앞 블록(제목 또는 짧은 문단)이 순서·절차를 말하는지 */
export const isStepsContextText = (text) => {
  const value = String(text || '').trim();
  if (!value || value.length > CONTEXT_MAX_CHARS) return false;
  return STEP_CONTEXT_RE.test(value);
};

/** 원문 블록 하나(제목·문단)가 다음 번호 목록의 단계 맥락인지 — 블록별로 나눠 그릴 때 앞 블록을 본다 */
export const isStepsContextBlock = (markdown) => {
  const value = String(markdown || '').trim();
  if (!value || value.includes('\n\n') || /^\s*(?:[-*+]|\d+[.)])\s/.test(value)) return false;
  return isStepsContextText(value.replace(/^#{1,6}\s+/, '').replace(/[*_`]/g, ''));
};

const isSteps = (list, prev, stepsContext) => {
  if (list.type !== 'list' || !list.ordered) return false;
  const items = list.children || [];
  if (items.length < STEPS_MIN_ITEMS || items.some((item) => typeof item.checked === 'boolean')) return false;
  const context = prev
    ? (['heading', 'paragraph'].includes(prev.type) && isStepsContextText(textOf(prev)))
    : stepsContext;
  if (context) return true;
  const stepLeads = items.filter((item) => STEP_LEAD_RE.test(textOf(item.children?.[0]).slice(0, 20))).length;
  return stepLeads * 2 >= items.length;
};

const isChecklist = (list) => list.type === 'list'
  && (list.children || []).length > 0
  && list.children.every((item) => typeof item.checked === 'boolean');

const markLists = (parent, stepsContext) => {
  (parent.children || []).forEach((node, index) => {
    if (node.type === 'blockquote') markLists(node, false);
    if (node.type !== 'list') return;
    (node.children || []).forEach((item) => markLists(item, false));
    if (isChecklist(node)) addClass(node, 'wq-checklist');
    else if (parent.type === 'root' && isSteps(node, parent.children[index - 1], stepsContext)) addClass(node, 'wq-steps');
  });
};

export default function remarkAnswerParts(options = {}) {
  const stepsContext = options.stepsContext === true;
  return (tree) => {
    markLists(tree, stepsContext);
  };
}
